import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'mandatory-approver-group-names';

const validator = () => null;
// Changed the Add Approvers title to 'Add Business and Technical Approvers'
const vFParams = {
  fieldTitle: 'Add Business and Technical Approvers',
};

const mandatoryApproverGroupNames = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { mandatoryApproverGroupNames };
